var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-5 pr-5 left-menu-inner"},[_c('ul',{staticClass:"m-nav"},_vm._l((_vm.leftLinks),function(link,index){return _c('li',{key:index,staticClass:"m-nav-item"},[_c('router-link',{staticClass:"m-nav-link",attrs:{"to":link.to,"active-class":"active"}},[_c('span',[_vm._v(_vm._s(link.title))])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }